<wz-async-content [isLoading]="!risk || !subscriptionData">
  <wz-form-group
    [formGroupControl]="formGroup"
    [excludedControls]="['financial']"
    [expandable]="true"
  >
    <wz-form-group-header>
      <mat-icon>insert_drive_file</mat-icon>
      Informations nécessaires
    </wz-form-group-header>
    <wz-form-group-part [formGroup]="assurePrincipalCtrl">
      <wz-form-group-part-header
        >Assuré Principal -
        {{ risk.assure | fullName }}</wz-form-group-part-header
      >
      <wz-form-group-part-item class="compact">
        <div class="block">
          <div class="controls">
            <mat-form-field>
              <input
                [mask]="'0 00 00 0A 000 000 00'"
                matInput
                placeholder="N° de sécurité sociale"
                formControlName="numeroSS"
              />
              <mat-error
                *ngIf="assurePrincipalCtrl.get('numeroSS').hasError('required')"
                wzI18n="FORMS_NUMSS_REQUIRED"
              >
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <wz-num-orga-affiliation-input
                placeholder="N° d'organisme d'affiliation"
                formControlName="numeroOrganismeAffiliation"
              >
              </wz-num-orga-affiliation-input>
              <mat-hint>Ne pas renseigner si inconnu</mat-hint>
              <mat-error
                *ngIf="
                  assurePrincipalCtrl
                    .get('numeroOrganismeAffiliation')
                    .hasError('required')
                "
                wzI18n="FORMS_NUMORGAAFFILIATION_REQUIRED"
              >
              </mat-error>
              <mat-error
                *ngIf="
                  assurePrincipalCtrl
                    .get('numeroOrganismeAffiliation')
                    .hasError('pattern')
                "
                wzI18n="FORMS_NUMORGAAFFILIATION_PATTERN"
              >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </wz-form-group-part-item>
    </wz-form-group-part>

    <wz-form-group-part *ngIf="partnerCtrl" [formGroup]="partnerCtrl">
      <wz-form-group-part-header
        >Conjoint - Né le {{ risk.family.conjoint?.personData?.dateNaissance }}
      </wz-form-group-part-header>
      <wz-form-group-part-item class="compact">
        <div class="block">
          <wz-button-toggle
            enumItemsKey="CIVILITY_ENUM"
            formControlName="civilite"
            orientation="row"
            title="Civilité *"
          >
          </wz-button-toggle>
          <div class="controls mt-8">
            <mat-form-field>
              <wz-text-input
                placeholder="Nom du conjoint"
                formControlName="nom"
              ></wz-text-input>
              <mat-error *ngIf="partnerCtrl.get('nom').hasError('required')"
                >Le nom du conjoint est obligatoire
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <wz-text-input
                placeholder="Prénom du conjoint"
                formControlName="prenom"
              ></wz-text-input>
              <mat-error *ngIf="partnerCtrl.get('prenom').hasError('required')"
                >Le prénom du conjoint est obligatoire
              </mat-error>
            </mat-form-field>
          </div>

          <div class="benef">
            <wz-rect-button
              *ngIf="
                !partnerCtrl.get('beneficiaryOf').value;
                else partnerUnlinkTmp
              "
              [raised]="false"
              color="accent"
              (click)="linkPartnerToYou()"
            >
              <mat-icon>link</mat-icon>
              Rattacher à l'assuré principal
            </wz-rect-button>
            <ng-template #partnerUnlinkTmp>
              <wz-rect-button
                [raised]="false"
                color="warn"
                (click)="unlink(partnerCtrl)"
              >
                <mat-icon>link_off</mat-icon>
                Détacher le conjoint de l'assuré principal
              </wz-rect-button>
            </ng-template>
          </div>
          <div class="controls">
            <mat-form-field *ngIf="partnerCtrl.get('numeroSS').enabled">
              <input
                [mask]="'0 00 00 0A 000 000 00'"
                matInput
                placeholder="N° de sécurité sociale"
                formControlName="numeroSS"
              />
              <mat-error
                *ngIf="partnerCtrl.get('numeroSS').hasError('required')"
                wzI18n="FORMS_NUMSS_REQUIRED"
              >
              </mat-error>
            </mat-form-field>
            <mat-form-field
              *ngIf="partnerCtrl.get('numeroOrganismeAffiliation').enabled"
            >
              <wz-num-orga-affiliation-input
                placeholder="N° d'organisme d'affiliation"
                formControlName="numeroOrganismeAffiliation"
              ></wz-num-orga-affiliation-input>
              <mat-hint>Ne pas renseigner si inconnu</mat-hint>
              <mat-error
                *ngIf="
                  partnerCtrl
                    .get('numeroOrganismeAffiliation')
                    .hasError('required')
                "
                wzI18n="FORMS_NUMORGAAFFILIATION_REQUIRED"
              >
              </mat-error>
              <mat-error
                *ngIf="
                  partnerCtrl
                    .get('numeroOrganismeAffiliation')
                    .hasError('pattern')
                "
                wzI18n="FORMS_NUMORGAAFFILIATION_PATTERN"
              >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </wz-form-group-part-item>
    </wz-form-group-part>

    <ng-container *ngIf="childrenCtrl">
      <wz-form-group-part
        *ngFor="let childCtrl of childrenCtrl.controls; let i = index"
      >
        <wz-form-group-part-header
          >Enfant {{ i + 1 }} - Né le
          {{ risk.family.enfants?.[i]?.personData?.dateNaissance ?? '' }}
        </wz-form-group-part-header>
        <wz-form-group-part-item [formGroup]="childCtrl" class="compact">
          <div class="block">
            <wz-button-toggle
              enumItemsKey="CIVILITY_ENUM"
              formControlName="civilite"
              orientation="row"
              title="Civilité *"
            >
            </wz-button-toggle>
            <div class="controls mt-8">
              <mat-form-field>
                <wz-text-input
                  placeholder="Nom de l'enfant"
                  formControlName="nom"
                ></wz-text-input>
                <mat-error *ngIf="childCtrl.get('nom').hasError('required')"
                  >Le nom de l'enfant est obligatoire
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <wz-text-input
                  placeholder="Prénom de l'enfant"
                  formControlName="prenom"
                >
                </wz-text-input>
                <mat-error *ngIf="childCtrl.get('prenom').hasError('required')"
                  >Le prénom de l'enfant est obligatoire
                </mat-error>
              </mat-form-field>
            </div>
            <div class="benef">
              <ng-container
                *ngIf="
                  !childCtrl.get('beneficiaryOf').value;
                  else childUnlinkTmp
                "
              >
                <wz-rect-button
                  [raised]="false"
                  color="accent"
                  (click)="linkToYou(childCtrl)"
                >
                  <mat-icon>link</mat-icon>
                  Rattacher à l'assuré principal
                </wz-rect-button>
                <wz-rect-button
                  *ngIf="partnerCtrl && !partnerCtrl.get('beneficiaryOf').value"
                  [raised]="false"
                  color="accent"
                  (click)="linkToPartner(childCtrl)"
                >
                  <mat-icon>link</mat-icon>
                  Rattacher au conjoint
                </wz-rect-button>
              </ng-container>
              <ng-template #childUnlinkTmp>
                <wz-rect-button
                  [raised]="false"
                  color="warn"
                  (click)="unlink(childCtrl)"
                >
                  <mat-icon>link_off</mat-icon>
                  <span *ngIf="childCtrl.get('beneficiaryOf').value == 1"
                    >Détacher l'enfant de l'assuré principal</span
                  >
                  <span *ngIf="childCtrl.get('beneficiaryOf').value == 2"
                    >Détacher l'enfant du conjoint</span
                  >
                </wz-rect-button>
              </ng-template>
            </div>
            <div class="controls">
              <mat-form-field *ngIf="childCtrl.get('numeroSS').enabled">
                <input
                  [mask]="'0 00 00 0A 000 000 00'"
                  matInput
                  placeholder="N° de sécurité sociale"
                  formControlName="numeroSS"
                />
                <mat-error
                  *ngIf="childCtrl.get('numeroSS').hasError('required')"
                  wzI18n="FORMS_NUMSS_REQUIRED"
                >
                </mat-error>
              </mat-form-field>
              <mat-form-field
                *ngIf="childCtrl.get('numeroOrganismeAffiliation').enabled"
              >
                <wz-num-orga-affiliation-input
                  placeholder="N° d'organisme d'affiliation"
                  formControlName="numeroOrganismeAffiliation"
                ></wz-num-orga-affiliation-input>
                <mat-hint>Ne pas renseigner si inconnu</mat-hint>
                <mat-error
                  *ngIf="
                    childCtrl
                      .get('numeroOrganismeAffiliation')
                      .hasError('required')
                  "
                  wzI18n="FORMS_NUMORGAAFFILIATION_REQUIRED"
                >
                </mat-error>
                <mat-error
                  *ngIf="
                    childCtrl
                      .get('numeroOrganismeAffiliation')
                      .hasError('pattern')
                  "
                  wzI18n="FORMS_NUMORGAAFFILIATION_PATTERN"
                >
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </wz-form-group-part-item>
      </wz-form-group-part>
    </ng-container>
  </wz-form-group>
  <wz-form-group [formGroupControl]="mainRibCtrl">
    <wz-form-group-header>
      <mat-icon>account_balance_wallet</mat-icon>
      Vos informations bancaires
    </wz-form-group-header>
    <wz-form-group-part-header>Prélèvements</wz-form-group-part-header>
    <wz-form-group-part class="form-container" [formGroup]="financialCtrl">
      Jour de prélèvement :
      <wz-button-toggle
        [items]="quantiemeList"
        formControlName="quantieme"
        orientation="row"
        class="quantieme-button-toggle"
      >
      </wz-button-toggle>

      <wz-form-group-part-item formGroupName="mainRib" class="compact">
        <wz-form-group-part-header
          >Coordonnées bancaires</wz-form-group-part-header
        >
        <div class="block">
          <div class="controls">
            <mat-form-field>
              <input
                matInput
                [mask]="getMask()"
                formControlName="iban"
                name="iban"
                [placeholder]="'RIB_IBAN' | wzI18n"
              />
              <mat-error
                *ngIf="mainRibCtrl.get('iban').hasError('required')"
                wzI18n="FORMS_IBAN_REQUIRED"
              >
              </mat-error>
              <mat-error *ngIf="mainRibCtrl.get('iban').hasError('prefix')">
                {{ mainRibCtrl.get('iban').errors['prefix'] }}
              </mat-error>
              <mat-error *ngIf="mainRibCtrl.get('iban').hasError('iban')"
                >Le format est incorrect.
              </mat-error>
            </mat-form-field>
          </div>
          <wz-button-toggle
            enumItemsKey="CIVILITY_ENUM"
            formControlName="civilityHolder"
            orientation="row"
            title="Civilité *"
          >
          </wz-button-toggle>
          <div class="controls mt-8">
            <mat-form-field>
              <wz-text-input
                formControlName="lastNameHolder"
                [placeholder]="'RIB_HOLDER_LASTNAME' | wzI18n"
              >
              </wz-text-input>
              <mat-error
                *ngIf="mainRibCtrl.get('lastNameHolder').hasError('required')"
                wzI18n="FORMS_LASTNAME_REQUIRED"
              ></mat-error>
            </mat-form-field>
            <mat-form-field>
              <wz-text-input
                formControlName="firstNameHolder"
                [placeholder]="'RIB_HOLDER_FIRSTNAME' | wzI18n"
              >
              </wz-text-input>
              <mat-error
                *ngIf="mainRibCtrl.get('firstNameHolder').hasError('required')"
                wzI18n="FORMS_FIRSTNAME_REQUIRED"
              ></mat-error>
            </mat-form-field>
          </div>
        </div>
        <wz-address-picker
          addressRepository="smalltox"
          formControlName="address"
          [isAlreadyFullAddress]="true"
        >
        </wz-address-picker>
      </wz-form-group-part-item>
    </wz-form-group-part>
  </wz-form-group>
</wz-async-content>
